
export default {
  styleOverrides: {
    root: {
      fontFamily: 'Inter, sans-serif',
    }
  },
}
